<nav class="navbar navbar-expand-md fixed-top flex-fill unselectable-text">
	<!-- header -->
	<div class="navbar-header ps-2 pe-2 ms-3 mt-2 text-center">
		<a class="navbar-brand m-0 w-100" role="button" (click)="goToDashboard()">
			<img src="./assets/img/logo.png" alt="lightning logo" width="65px" />
			<span class="ms-1 fw-bold fs-2 topbar-blue-button">{{ appName }}</span>
		</a>
	</div>
	<!-- left box -->
	<ul class="navbar-nav flex-fill mt-1 ms-2 align-items-center left-nav">
		<li class="fw-bold fs-4 ms-3">{{ currentPageTitle }}</li>
	</ul>

	<!-- right menu -->
	<div class="collapse navbar-collapse right-nav" id="collapseBasic">
		<ul class="navbar-nav">
			<li class="nav-item me-1" *ngIf="!isPrescriber">
				<app-notification-manager
					[optimNotifications]="optimNotifications"
				></app-notification-manager>
			</li>
			<li class="nav-item me-1" *ngIf="!isPrescriber">
				<app-messaging-notification-manager
					[messagingNotifications]="messagingNotifications"
				></app-messaging-notification-manager>
			</li>
			<div class="btn-group me-3" dropdown placement="bottom right">
				<button
					title="Espace personnel"
					dropdownToggle
					type="button"
					class="btn nav-link"
				>
					<i class="bi bi-person topbar-blue-button" aria-hidden="true"></i>
				</button>

				<ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
					<li
						class="list-group-item unselectable-text text-center fs-6 pt-2 fw-bold"
						*ngIf="!isPrescriber"
					>
						<span>
							{{ currentEmployee.firstName }}
							{{ currentEmployee.lastName | uppercase }}</span
						>
					</li>
					<hr *ngIf="!isPrescriber" />
					<li *ngIf="!isPrescriber">
						<a class="dropdown-item" routerLink="/espace-perso/profil"
							>Mon profil</a
						>
					</li>
					<li *ngIf="!isPrescriber">
						<a class="dropdown-item" routerLink="/espace-perso/securite"
							>Gestion du compte</a
						>
					</li>
					<li>
						<a
							class="dropdown-item"
							role="button"
							(click)="openModal(signOutModal)"
						>
							Se déconnecter
						</a>
					</li>
				</ul>
			</div>
		</ul>
	</div>
</nav>

<ng-template #signOutModal>
	<div class="modal-header">
		<h4 class="modal-title text-center">
			Êtes-vous sûr de vouloir vous déconnecter ?
		</h4>
		<button
			type="button"
			class="btn-close close pull-right"
			aria-label="Close"
			(click)="modalRef?.hide()"
		>
			<span aria-hidden="true" class="visually-hidden">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div class="d-flex justify-content-evenly">
			<button class="btn theme-main-color-button" (click)="modalRef?.hide()">
				Retour
			</button>
			<button class="btn theme-red-button" (click)="signOut()">
				Se déconnecter
			</button>
		</div>
	</div>
</ng-template>
